import React from 'react';
// import { getLogo} from "../../commons/js/util";
import { useNomenclator } from '../../contexts/nomenclatorContext';
import styled from 'styled-components/macro';
import { fmt } from '../../utils/fmtUtils';
import Logo from '../../containers/Logo';
import { useTranslate } from '../../contexts/languageContext';

const TablaTerritorios_CuerpoFilaTerritorio = ({ data }) => {
  const nomenclator = useNomenclator();
  const t = useTranslate();

  const par = nomenclator.partidos[Number(data.codpar) - 1];
  // const codpar = getLogo(par.codpar,'es','act');
  const nompar = par === undefined ? '' : par.nombre;
  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', paddingTop: '6px', paddingBottom: '6px', borderTop: '2px solid #dadada', alignItems: 'center', textAlign: "center" }}>
      <div style={{ width: '20%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center' }}>{data.nombre}</div>
      <div style={{ width: '40%', display: 'flex', flexDirection: 'col', alignContent: 'center', alignItems: 'center' }}>
        {(parseInt(data.mesesc) > 0) &&
          <>
            {data.hayEmpate === "1"
              ?
              <>
                <span style={{ paddingLeft: '55px', }}>{t("empate")}</span>
              </>
              :
              <>
                <StyledLogo codpar={par.codpar} height={'50px'} width={'50px'} />
                <span style={{ paddingLeft: '5px', alignItems: "center", display: "flex", justifyContent: "center", flexGrow: "1" }}>{nompar}</span>
              </>
            }
          </>
        }
      </div>
      <div style={{ width: '20%', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        <span style={{ marginRight: '8px' }}>
          {'(' + fmt(data.mesesc) + ')'}
        </span>
        <span className="percent">
          {data.pmesesc}
        </span>
      </div>
      <div style={{ width: '20%', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        <span style={{ marginRight: '8px' }}>
          {'(' + fmt(data.votant) + ')'}
        </span>
        <span className="percent">
          {data.pvotant}
        </span>
      </div>
    </div>
  );
};

const StyledLogo = styled(Logo)`
  padding-top: 5px;
  /* top: 5px; */
  /* height: 50px; */
  width: ${({ height }) => height};
`;

export default TablaTerritorios_CuerpoFilaTerritorio;
